export default __webpack_public_path__ + "static/media/imageBlackwhite1.ee8f3daa.jpg";